<template>
  <div class="event-analysis-main-container">
    <t-loading attach=".event-analysis-main-container" v-if="initLoading"></t-loading>
    <div class="header">
      <div class="left">
        <span class="back" v-if="!!formComponent.boardId" @click="handleBack">
          <icon name="chevron-left" />
        </span>
        <!--<div class="tit">{{ headTitle }}</div>-->
        <t-breadcrumb style="margin-right: 20px">
          <t-breadcrumb-item>{{ headTitle }}</t-breadcrumb-item>
        </t-breadcrumb>
        <div class="mdRemod">
          <img :src="bookHref" style="margin-right: 5px" alt="" />
          <a href="https://docs.qq.com/doc/DV0lOY2ZPYVJmZGdt" target="_blank">说明文档</a>
        </div>
        <!--<new-guide-trigger class="new-guide-trigger" @click="handleStartGuide"></new-guide-trigger>-->
      </div>
      <div class="right">
        <t-button variant="outline" @click="handleShowSavePopover">
          <icon name="save" slot="icon" />
          保存
        </t-button>
      </div>
    </div>

    <my-card class="" shadow="never">
      <div slot="header" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析条件</div>
        </div>
        <div class="right">
          <t-switch size="medium" v-model="showAnalysisConditions"></t-switch>
          <span style="margin-left: 10px">{{ showAnalysisConditions ? '展开' : '收起' }}</span>
        </div>
      </div>
      <div style="padding-left: 20px; transition: all 0.3s linear" v-show="showAnalysisConditions">
        <div class="panel-row new-guide-step-1">
          <div class="left">
            <div class="label">指标</div>
          </div>
          <div class="zhibiao-cont">
            <div>
              <div class="zhibiao-item" v-for="(zhibiaoItem, zhibiaoItemIdx) in zhibiaoList" :key="zhibiaoItemIdx">
                <div class="zhibiao-title-cont">
                  <div class="zhibiao-idx">{{ zhibiaoItemIdx | intToUpperChar }}</div>
                  <t-input
                    size="medium"
                    v-model="zhibiaoItem.zhibiaoTitle"
                    @change="handleZhibiaoTitleChange(zhibiaoItem)"
                    class="zhibiao-title"
                    :maxlength="20"
                  ></t-input>
                  <t-button size="medium" variant="outline" @click="handleAddZhibiaoFilterItem(zhibiaoItem)">
                    <icon name="add" slot="icon" />
                    筛选项
                  </t-button>
                  <div style="margin-left: auto">
                    <!--<t-button-->
                    <!--  theme="primary"-->
                    <!--  variant="text"-->
                    <!--  size="small"-->
                    <!--  v-show="zhibiaoList.length > 1"-->
                    <!--  @click="handleRemoveZhibiao(zhibiaoItemIdx)"-->
                    <!--&gt;-->
                    <!--  删除-->
                    <!--</t-button>-->
                    <t-button
                      shape="circle"
                      variant="text"
                      size="small"
                      v-show="zhibiaoList.length > 1"
                      @click="handleRemoveZhibiao(zhibiaoItemIdx)"
                    >
                      <icon name="delete" slot="icon" />
                    </t-button>
                  </div>
                </div>
                <div class="zhibiao-body-cont">
                  <div class="event-config-cont">
                    <div
                      class="event-item"
                      v-for="(eventItem, eventItemIdx) in zhibiaoItem.eventList"
                      :key="eventItemIdx"
                    >
                      <div style="margin: 0 0 0 0; width: 70px" v-if="eventItemIdx">
                        <t-select
                          size="medium"
                          v-model="eventItem.targetOperator"
                          placeholder="请选择"
                          class=""
                          style=""
                        >
                          <t-option v-for="eo in eventOperatorOptions" :key="eo.val" :label="eo.label" :value="eo.val">
                            {{ eo.val | targetUnitLabel }}
                          </t-option>
                        </t-select>
                      </div>
                      <div class="event-main">
                        <div
                          class="kuohao left"
                          :style="{ visibility: zhibiaoItem.eventList.length > 1 ? 'visible' : 'hidden' }"
                          :class="{ selected: eventItem.leftBracket }"
                          @click="handleToggleZhibiaoEventBracket(zhibiaoItem, eventItem, 'leftBracket')"
                        >
                          (
                        </div>
                        <div style="display: flex; align-items: center">
                          <t-select
                            v-model="eventItem.eventName"
                            @change="handelEventChange(zhibiaoItem, eventItem, $event)"
                            filterable
                            placeholder="请选择"
                            size="medium"
                            style="width: 160px; max-width: 200px; display: inline-block"
                          >
                            <t-option
                              v-for="item in eventSelectOptions"
                              :key="item.id"
                              :label="item.eventShowName"
                              :value="item.eventName"
                            ></t-option>
                          </t-select>
                          <t-popup placement="bottom-left" v-model="eventItem.showPopover" trigger="click">
                            <template #content>
                              <my-card
                                shadow="never"
                                v-if="eventItem.popoverStep === 2"
                                style="max-width: 700px; min-width: 500px"
                              >
                                <div slot="header" class="">
                                  <span>{{ getEventShowName(eventItem) }}</span>
                                  <span style="color: grey; margin: 0 10px 0 10px">/</span>
                                  <span style="color: grey">筛选条件</span>
                                </div>
                                <div>
                                  <div style="display: flex; margin-bottom: 10px; align-items: center">
                                    <!--<div>属性关系</div>-->
                                    <!--<t-radio-group v-model="eventItem.filterType" style="margin: 0 20px 0 20px">-->
                                    <!--  <t-radio value="or">或</t-radio>-->
                                    <!--  <t-radio value="and">且</t-radio>-->
                                    <!--</t-radio-group>-->
                                    <t-button
                                      variant="outline"
                                      size="medium"
                                      @click="handleAddZhibiaoEventFilterItem(eventItem)"
                                    >
                                      <icon name="add" slot="icon" />
                                      筛选项
                                    </t-button>
                                  </div>
                                  <div
                                    v-if="eventItem.filterList.length"
                                    style="background-color: #fafafa; padding: 8px 10px 8px 0"
                                  >
                                    <condition-filter
                                      size="medium"
                                      :filter-type.sync="eventItem.filterType"
                                      :filter-list="eventItem.filterList"
                                      :condition-operator-options="conditionOperatorOptions"
                                      :condition-property-options="calEventPropOptions(eventItem)"
                                    ></condition-filter>
                                  </div>
                                  <div style="display: flex; justify-content: center; margin-top: 20px">
                                    <t-button
                                      theme="default"
                                      size="medium"
                                      @click="handleHideEventPopover(zhibiaoItem, eventItem)"
                                    >
                                      取消
                                    </t-button>
                                    <t-button
                                      theme="primary"
                                      size="medium"
                                      @click="handleHideEventPopover(zhibiaoItem, eventItem)"
                                    >
                                      确定
                                    </t-button>
                                  </div>
                                </div>
                              </my-card>
                            </template>
                            <div class="event-filter" @click="handleShowEventPopover(zhibiaoItem, eventItem, 2)">
                              <icon
                                name="filter"
                                class="filter-icon"
                                :class="{ selected: eventItem.filterList.length }"
                              />
                              <span>筛选条件</span>
                            </div>
                          </t-popup>
                        </div>
                        <div style="padding: 0 6px 0 6px">的</div>
                        <event-analysis-target-column
                          size="small"
                          v-model="eventItem.eventTargetColumn"
                          :options="getEventTargetColumnOptions(eventItem)"
                          @onChange="handleEventTargetColumnChange(zhibiaoItem, eventItem)"
                        ></event-analysis-target-column>
                        <div
                          class="kuohao right"
                          :style="{ visibility: zhibiaoItem.eventList.length > 1 ? 'visible' : 'hidden' }"
                          :class="{ selected: eventItem.rightBracket }"
                          @click="handleToggleZhibiaoEventBracket(zhibiaoItem, eventItem, 'rightBracket')"
                        >
                          )
                        </div>

                        <icon
                          name="close"
                          class="close"
                          v-if="zhibiaoItem.eventList.length > 1"
                          @click="handleRemoveZhibiaoEvent(zhibiaoItem, eventItemIdx)"
                        />
                      </div>
                    </div>
                    <t-button
                      theme="primary"
                      variant="text"
                      size="medium"
                      @click="handleAddZhibiaoEvent(zhibiaoItem)"
                      class="hover-show"
                    >
                      <icon name="add" />
                      组合
                    </t-button>
                  </div>
                  <div class="zhibiao-conditions-cont" v-show="zhibiaoItem.filterList.length">
                    <!--<div class="zhibiao-conditions-type-cont" v-show="zhibiaoItem.filterList.length > 1">-->
                    <!--  <div>属性关系</div>-->
                    <!--  <t-radio-group v-model="zhibiaoItem.filterType" style="margin: 0 10px 0 20px">-->
                    <!--    <t-radio value="or">或</t-radio>-->
                    <!--    <t-radio value="and">且</t-radio>-->
                    <!--  </t-radio-group>-->
                    <!--</div>-->

                    <condition-filter
                      size="medium"
                      :filter-type.sync="zhibiaoItem.filterType"
                      :filter-list="zhibiaoItem.filterList"
                      :condition-operator-options="conditionOperatorOptions"
                      :condition-property-options="calZhibiaoPropOptions(zhibiaoItem)"
                    ></condition-filter>
                  </div>
                </div>
              </div>
            </div>
            <t-button
              class="new-guide-step-2"
              size="medium"
              theme="default"
              variant="outline"
              @click="handleAddZhibiao"
              style="margin-top: 20px"
            >
              <icon name="add" slot="icon" />
              自定义指标
            </t-button>
          </div>
        </div>

        <div class="divider" />

        <div class="panel-row new-guide-step-3">
          <div class="left">
            <div class="label">全局筛选</div>
          </div>
          <div class="global-filter-cont">
            <div class="filter-body" v-show="controlGroupList.length">
              <div class="control-group-item" v-for="(cg, idx) in controlGroupList" :key="idx">
                <div class="title-cont">
                  <div class="idx">{{ idx + 1 }}</div>
                  <t-input class="title" v-model="cg.name"></t-input>
                  <div class="hover-show oper">
                    <t-button variant="outline" @click="handleAddCgFilterItem(cg)">
                      <icon name="add" slot="icon" />
                      筛选项
                    </t-button>
                    <t-button
                      theme="primary"
                      variant="text"
                      v-if="controlGroupList.length > 1"
                      @click="handleRemoveControlGroup(cg, idx)"
                    >
                      删除
                    </t-button>
                  </div>
                </div>
                <div class="condition-cont" v-if="cg.filterList.length">
                  <condition-filter
                    size="medium"
                    :filter-type.sync="cg.filterType"
                    :filter-list="cg.filterList"
                    :condition-operator-options="conditionOperatorOptions"
                    :condition-property-options="calGlobalPropOptions(conditionPropertyOptions)"
                    @onEmpty="handleCgFilterEmpty(cg, idx)"
                  ></condition-filter>
                </div>
              </div>
            </div>

            <div class="filter-header">
              <t-button size="medium" theme="default" variant="outline" @click="handleAddControlGroup">
                <icon name="add" slot="icon" />
                新增对照组
              </t-button>
            </div>
          </div>
        </div>

        <!--<div class="panel-row new-guide-step-4">-->
        <!--  <div class="left">-->
        <!--    <div class="label">选择人群</div>-->
        <!--  </div>-->
        <!--  <div class="weidu-cont">-->
        <!--    &lt;!&ndash;            <div>按</div>&ndash;&gt;-->
        <!--    <div class="weidu-item">-->
        <!--      <t-select-->
        <!--        size="medium"-->
        <!--        v-model="renqunItem.val"-->
        <!--        v-for="(renqunItem, renqunItemIdx) in renqunWeiduList"-->
        <!--        :key="renqunItemIdx"-->
        <!--        placeholder="请选择"-->
        <!--        style=""-->
        <!--      >-->
        <!--        <t-option-->
        <!--          v-for="(renqunOption, renqunOptionIdx) in renqunWeiduOptions"-->
        <!--          :key="renqunOptionIdx"-->
        <!--          :label="renqunOption.label"-->
        <!--          :value="renqunOption.value"-->
        <!--        ></t-option>-->
        <!--      </t-select>-->
        <!--    </div>-->
        <!--  </div>-->
        <!--</div>-->

        <div class="panel-row new-guide-step-5">
          <div class="left">
            <div class="label" style="position: relative">
              分组展示维度
              <!--<t-tooltip class="item" content="分析结果将会按照所选维度做分组展示">-->
              <!--  <icon name="help-circle" />-->
              <!--</t-tooltip>-->
            </div>
          </div>
          <div class="weidu-cont">
            <div
              class="weidu-item"
              v-for="(shuxingItem, shuxingItemIdx) in shuxingWeiduList"
              :key="shuxingItem.val + shuxingItemIdx"
            >
              <select-props
                size="medium"
                v-model="shuxingItem.val"
                :show-total="true"
                :condition-property-options="calGlobalPropOptions(shuxingWeiduOptions)"
                @change="handleShuxingWeiduChange"
              ></select-props>

              <icon
                name="close"
                class="close"
                @click="handleRemoveShuxingWeidu(shuxingItemIdx)"
                v-if="shuxingWeiduList.length > 0"
              />
            </div>
            <t-button
              @click="handleAddShuXingWeidu"
              size="medium"
              theme="default"
              variant="outline"
              style="margin-left: 5px"
            >
              <icon name="add" slot="icon" />
              属性
            </t-button>
          </div>
        </div>

        <div class="panel-row">
          <t-button size="medium" theme="primary" :loading="loadingData" @click="handleGetData" style="width: 80px">
            查询
          </t-button>
          <t-button size="medium" variant="outline" @click="handleReset" style="width: 80px">重置</t-button>
        </div>
      </div>
    </my-card>

    <my-card class="" shadow="never" style="margin-top: 20px">
      <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
        <div class="title">分析图表</div>
        <div>
          <t-select size="medium" v-model="chartType" placeholder="请选择" style="min-width: 100px">
            <t-option label="折线图" value="chart_line"></t-option>
            <t-option label="柱状图" value="histogram"></t-option>
            <t-option label="条形图" value="stacked_bar_chart"></t-option>
            <t-option label="环形图" value="circular_graph" :disabled="isDisabledCircular"></t-option>
          </t-select>
        </div>
      </div>

      <div>
        <div class="top" style="display: flex; justify-content: space-between">
          <div class="date-range-cont" style="display: flex; align-items: center" slot="date-range">
            <t-select size="medium" v-model="formUnit" placeholder="请选择" style="width: 90px; margin-right: 10px">
              <t-option label="按天" value="day"></t-option>
              <t-option label="按小时" value="hour" :disabled="isDisabledByChartType"></t-option>
            </t-select>
            <date-range-picker size="medium" v-model="dateInfo" :picker-options="datePickerOptions"></date-range-picker>
            <div style="margin: 0 10px 0 10px" v-show="formShowCompareDate">对比</div>
            <date-range-picker
              size="medium"
              v-show="formShowCompareDate"
              v-model="compareDateInfo"
              :picker-options="datePickerOptions"
            ></date-range-picker>
            <t-button
              variant="outline"
              size="medium"
              class="margin-item"
              style="margin-left: 10px"
              v-show="!formShowCompareDate"
              @click="handleAddCompareDate"
            >
              <icon name="add" slot="icon" />
              对比时间
            </t-button>
            <t-button
              theme="primary"
              variant="text"
              class="margin-item"
              v-show="formShowCompareDate"
              @click="handleRemoveCompareDate"
            >
              删除
            </t-button>
          </div>
          <div style="display: flex">
            <t-select
              v-model="topN"
              @change="handleChangeTopN"
              placeholder="请选择"
              class=""
              style="width: 100px; margin-right: 8px"
            >
              <t-option
                v-for="item in topNOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></t-option>
            </t-select>
            <t-input
              placeholder="请输入关键词过滤"
              v-model="legendSearchWord"
              clearable
              @change="handleLegendSearchWordChange"
              style="width: 160px"
            >
              <icon name="search" slot="suffix-icon" />
            </t-input>
          </div>
        </div>
        <div class="chart" style="padding-top: 20px" v-if="loadingData || legendData.length">
          <event-analysis-chart
            v-if="chartType === 'chart_line'"
            :loading="loadingData"
            :show-compare-date="showCompareDate"
            :legend-data="legendData"
            :options="chartOptions"
            :date-keys="dateKeys"
            :unit="unit"
            :top-number="topN"
            :search-word="legendSearchWord"
          ></event-analysis-chart>
          <event-analysis-histogram
            v-if="chartType === 'histogram'"
            :loading="loadingData"
            :show-compare-date="showCompareDate"
            :legend-data="legendData"
            :options="chartOptions"
            :date-keys="dateKeys"
            :unit="unit"
            :top-number="topN"
            :search-word="legendSearchWord"
          ></event-analysis-histogram>
          <event-analysis-stacked-bar-chart
            v-if="chartType === 'stacked_bar_chart'"
            :loading="loadingData"
            :show-compare-date="showCompareDate"
            :legend-data="legendData"
            :options="chartOptions"
            :date-keys="dateKeys"
            :unit="unit"
            :top-number="topN"
            :search-word="legendSearchWord"
          ></event-analysis-stacked-bar-chart>
          <event-analysis-circular-graph
            v-if="chartType === 'circular_graph'"
            :loading="loadingData"
            :show-compare-date="showCompareDate"
            :legend-data="legendData"
            :legend-data-wd="legendDataWd"
            :options="chartOptions"
            :date-keys="dateKeys"
            :unit="unit"
            :top-number="topN"
            :search-word="legendSearchWord"
          ></event-analysis-circular-graph>
        </div>

        <no-data v-else></no-data>
      </div>
    </my-card>

    <event-analysis-table
      v-if="tableShowType === 'row'"
      key="eventAnalysisTable"
      :date-keys="dateKeys"
      :unit="unit"
      :show-compare-date="showCompareDate"
      :zhibiao-list="zhibiaoList"
      :shuxing-weidu-list="shuxingWeiduList"
      :shuxing-weidu-options="conditionPropertyOptions"
      :condition-operator-options="conditionOperatorOptions"
      :last-get-data-params="lastGetDataParams"
      :last-get-data-params-compare="lastGetDataParamsCompare"
      :options="chartOptions"
      :loading="loadingData"
      @onChangeTableShowType="handleChangeTableShowType"
    ></event-analysis-table>

    <event-analysis-table-transform
      v-if="tableShowType === 'col'"
      key="eventAnalysisTableTransform"
      :change-trigger="changeTrigger"
      :date-keys="dateKeys"
      :unit="unit"
      :show-compare-date="showCompareDate"
      :zhibiao-list="zhibiaoList"
      :shuxing-weidu-list="shuxingWeiduList"
      :shuxing-weidu-options="conditionPropertyOptions"
      :condition-operator-options="conditionOperatorOptions"
      :last-get-data-params="lastGetDataParams"
      :last-get-data-params-compare="lastGetDataParamsCompare"
      :group-data-obj-list="groupDataObjList"
      :group-data-obj-list-compare="groupDataObjListCompare"
      :loading="loadingData"
      @onChangeTableShowType="handleChangeTableShowType"
    ></event-analysis-table-transform>

    <event-analysis-save
      v-if="savePopverVisible"
      key="eventAnalysisSave"
      :loading="loadingSave"
      :zhibiao-list="zhibiaoList"
      :shuxing-weidu-list="shuxingWeiduList"
      :form-data-bookmark="formBookmark"
      :form-data-component="formComponent"
      :board-info="boardInfo"
      :formUnit="formUnit"
      @onClose="savePopverVisible = false"
      @onSaveBookmark="handleSaveBookmark"
      @onSaveComponent="handleSaveComponent"
    ></event-analysis-save>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { uniq, uniqWith, trim, pick, cloneDeep } from 'lodash';
import { Icon } from 'tdesign-icons-vue';
import {
  getBookmarkDetail,
  saveBookmark,
  getEventAnalysisData,
  pollingEventData,
  getEventList,
  getTargetColumn,
  getAllProperty,
  getAllEventProperty,
  getConditionOperator,
  getPackageList,
} from '@/api/analysis/custom-analysis';
import { getBoardDetail, createComponent, modifyComponent, getComponentList } from '@/api/analysis/custom-overview';
import bookHref from '@/assets/icon/icon-link.svg';
import EventAnalysisTargetColumn from './components/event-analysis-target-column.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';
import EventAnalysisChart from './components/event-analysis-chart.vue';
import EventAnalysisHistogram from './components/event-analysis-histogram.vue';
import EventAnalysisStackedBarChart from './components/event-analysis-stacked-bar-chart.vue';
import EventAnalysisCircularGraph from './components/event-analysis-circular-graph.vue';
import EventAnalysisTable from './components/event-analysis-table.vue';
import EventAnalysisTableTransform from './components/event-analysis-table-transform.vue';
// import EventAnalysisSaveBookmark from './components/event-analysis-save-bookmark';
import EventAnalysisSave from './components/event-analysis-save.vue';
import SelectProps from '@/components/analysis/property-selector.vue';
import noData from '@/components/common/no-data-card.vue';
import DateRangePicker from '@/components/analysis/date-range-picker.vue';
import mixinGuide from '@/minxins/new-guide';

import {
  getDayLen,
  getDateKeys,
  PollingAction,
  colorArr,
  getDateArrFromObj,
  propertyArrJiaoJi,
  analysisDataTranslate,
  makeFilterList,
  extractMetaConfig,
} from '@/utils/helper';
import { getCharFromInt } from '@/utils/common';

// import { editTargetWarn } from '@/view/pages/target-warn/components/edit-target-warn';

const targetUnitLabelMap = {
  '+': '+ 加',
  '-': '- 减',
  '*': '* 乘',
  '/': '/ 除',
};

export default {
  name: 'customAnalysisEventAnalysis',
  mixins: [mixinGuide],
  components: {
    Icon,
    noData,
    EventAnalysisTargetColumn,
    ConditionFilter,
    EventAnalysisChart,
    EventAnalysisHistogram,
    EventAnalysisStackedBarChart,
    EventAnalysisCircularGraph,
    EventAnalysisTable,
    EventAnalysisTableTransform,
    EventAnalysisSave,
    SelectProps,
    DateRangePicker,
  },
  data() {
    return {
      bookHref,
      showAnalysisConditions: true,
      zhibiaoList: [
        {
          zhibiaoTitle: '自定义指标1',
          zhibiaoTitleUserChanged: false,
          eventList: [
            {
              eventName: '',
              eventShowName: '',
              targetOperator: '/',
              leftBracket: false,
              rightBracket: false,
              eventTargetColumn: { type: 'totalCount' },
              filterType: 'and',
              filterList: [],
              showPopover: false,
              popoverStep: 1,
            },
          ],
          filterType: 'and',
          filterList: [
            // { propertyName: 'channel', operator: 'ne', val: 'baidu1' },
          ],
        },
      ],

      eventSelectOptions: [
        // { eventName: 'addChart1', eventShowName: '加入购物车1' },
      ],

      eventOperatorOptions: [
        { label: '+', val: '+' },
        { label: '-', val: '-' },
        { label: '*', val: '*' },
        { label: '/', val: '/' },
      ],

      topNOptions: [
        { label: '前10项', value: 10 },
        { label: '前20项', value: 20 },
        { label: '前30项', value: 30 },
        { label: '前40项', value: 40 },
        { label: '前50项', value: 50 },
      ],

      eventTargetColumnDataMap: {},

      eventStatZhibiaoOptions: [
        // { label: '总次数', val: 'totalCount' },
      ],

      allEventProperty: [],

      conditionPropertyOptions: [
        // { propertyType: '', propertyName: 'channel', propertyDesc: '渠道', propertyDataType: 'string' },
      ],

      conditionOperatorOptions: [
        // { type: 'eq', desc: '等于', javaType: 'string', canMore: 2 },
      ],

      globalFilterType: 'and',
      globalFilterList: [
        // { column: '', conditionOperator: '', value: '' }
      ],

      controlGroupList: [
        {
          name: '全体用户',
          filterType: 'or',
          filterList: [{ column: '', conditionOperator: '', value: undefined }],
        },
        // {
        //   name: '',
        //   filterType: '',
        //   filterList: [
        //     { column: '', conditionOperator: '', value: '' },
        //     { column: '', conditionOperator: '', value: '' },
        //   ],
        // },
        // {
        //   name: '',
        //   filterType: '',
        //   filterList: [
        //     { column: '', conditionOperator: '', value: '' },
        //     { column: '', conditionOperator: '', value: '' },
        //   ],
        // },
      ],

      // baseDate: [],
      // compareDate: [],
      dateInfo: {},
      formUnit: 'day',
      formShowCompareDate: false,
      unit: 'day',
      compareDateInfo: {},
      showCompareDate: false,
      datePickerOptions: {
        disabledDate(time) {
          if (dayjs(time).isAfter(dayjs(new Date()), 'day')) {
            return true;
          }
          return false;
        },
      },

      renqunWeiduList: [], // [{ val: 'all' }]
      shuxingWeiduList: [], // [{ val: 'all' }, { val: 'country' }]

      renqunWeiduOptions: [],
      shuxingWeiduOptions: [],

      groupDataObjList: {},
      groupDataObjListCompare: {},
      chartData: {
        seriesMap: [],
        seriesMapCompare: [],
        legendData: [],
        legendDataWd: [], // 不带指标名称，只有维度
      },
      changeTrigger: 0, // 数据变化时，自增，用来触发其他组件更新

      tableShowType: 'row', // row - 日期是指标 col - 日期是维度

      topN: 10,
      legendSearchWord: '',

      initLoading: false,
      loadingData: false,
      loadingSave: false,

      savePopverVisible: false,
      formBookmark: {
        id: '',
        bookmarkName: '',
        remark: '',
      },
      formComponent: {
        id: '',
        name: '',
        boardId: '',
      },
      boardInfo: {},

      pa: null,
      pa2: null,

      lastGetDataParams: {},
      lastGetDataParamsCompare: {},
      chartType: 'chart_line', // 分析图表的类型
    };
  },
  computed: {
    headTitle() {
      return this.formComponent.name || this.formBookmark.bookmarkName || '事件分析';
    },
    isDisabledByChartType() {
      // 只有折线图支持按小时
      if (['chart_line'].indexOf(this.chartType) === -1) {
        return true;
      }
      return false;
    },
    isDisabledCircular() {
      // 只有选择了属性维度，才支持环形图
      const isFind = this.shuxingWeiduList.find(item => item.val !== 'all');
      if (!isFind) {
        return true;
      }
      return false;
    },
    chartOptions() {
      return {
        // showCompareDate: this.showCompareDate,
        seriesMap: this.chartData.seriesMap,
        seriesMapCompare: this.chartData.seriesMapCompare,
      };
    },
    legendData() {
      return this.chartData.legendData;
    },
    legendDataWd() {
      return this.chartData.legendDataWd;
    },

    baseDate() {
      return getDateArrFromObj(this.dateInfo || {});
    },

    compareDate() {
      return getDateArrFromObj(this.compareDateInfo || {});
    },

    dateKeys() {
      let dateDiff = getDayLen(this.baseDate[0], this.baseDate[1], this.unit);
      if (this.showCompareDate) {
        const compareDateDiff = getDayLen(this.compareDate[0], this.compareDate[1], this.unit);
        if (compareDateDiff > dateDiff) {
          dateDiff = compareDateDiff;
        }
      }
      const baseDateKeys = getDateKeys(this.baseDate[0], dateDiff, this.unit);
      let compareDateKeys;
      if (this.showCompareDate) {
        compareDateKeys = getDateKeys(this.compareDate[0], dateDiff, this.unit);
      }
      return {
        baseDateKeys,
        compareDateKeys,
        baseDate: this.baseDate,
        compareDate: this.compareDate,
      };
    },
    // ...mapGetters({ userInfo: 'userInfoState' }),
    // hasAddWarnRight() {
    //   const kaIds = [20, 40, 10002003, 10000761, 10000808, 10000161, 10002704, 10000022, 10000298, 10000040];
    //   const userIds = [61, 691, 1985, 7178, 9168, 9496];
    //   return kaIds.includes(this.userInfo.merchantId) && userIds.includes(this.userInfo.user_id);
    // },
  },
  watch: {
    $route(to, from) {
      this.routeChange(to, from);
    },
  },
  filters: {
    intToUpperChar(i) {
      return getCharFromInt(i);
    },
    targetUnitLabel(v) {
      return targetUnitLabelMap[v];
    },
  },
  created() {
    // console.log('event-analysis created ----------------------------', this.$route.query);
    this.initUrlParams();
    this.initData();
  },
  methods: {
    async routeChange() {
      this.initUrlParams();
      await this.initData();
    },

    resetAll() {
      this.resetConfig();
      this.resetExtInfo();
      this.resetAnalysisData();
    },

    resetConfig() {
      let eventName = '';

      if (this.eventSelectOptions.length) {
        eventName = this.eventSelectOptions[0].eventName;
      }
      this.zhibiaoList = [
        {
          zhibiaoTitle: '自定义指标1',
          zhibiaoTitleUserChanged: false,
          eventList: [
            {
              eventName,
              eventShowName: '',
              targetOperator: '/',
              leftBracket: false,
              rightBracket: false,
              eventTargetColumn: { type: 'totalCount' },
              filterType: 'and',
              filterList: [],
              showPopover: false,
              popoverStep: 1,
            },
          ],
          filterType: 'and',
          filterList: [],
        },
      ];

      this.globalFilterType = 'and';
      this.globalFilterList = [];
      this.controlGroupList = [
        {
          name: '全体用户',
          filterType: 'or',
          filterList: [{ column: '', conditionOperator: '', value: undefined }],
        },
      ];
      this.renqunWeiduList = [{ val: 'all' }];
      this.shuxingWeiduList = [{ val: 'all' }];

      this.dateInfo = {
        timeType: 'static',
        startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
        endTime: dayjs().subtract(1, 'day').format('YYYYMMDD'),
      };
      this.compareDateInfo = {
        timeType: 'static',
        startTime: dayjs().subtract(14, 'day').format('YYYYMMDD'),
        endTime: dayjs().subtract(8, 'day').format('YYYYMMDD'),
      };

      this.formShowCompareDate = false;
    },

    resetAnalysisData() {
      this.groupDataObjList = {};
      this.groupDataObjListCompare = {};
      this.chartData.legendData = [];
      this.chartData.legendDataWd = [];
      this.chartData.seriesMap = [];
      this.chartData.seriesMapCompare = [];
      this.tableShowType = 'row';

      this.topN = 10;
      this.legendSearchWord = '';
    },

    resetExtInfo() {
      this.savePopverVisible = false;
      this.formBookmark = {
        id: this.formBookmark.id, // id 不能重置
        bookmarkName: '',
        remark: '',
      };
      this.formComponent = {
        id: this.formComponent.id,
        name: '',
        boardId: this.formComponent.boardId,
      };
      this.boardInfo = {};
    },

    initUrlParams() {
      // 先清空，避免上次的残留
      this.formBookmark.id = '';
      this.formComponent.id = '';
      this.formComponent.boardId = '';

      if (this.$route.query.id || this.$route.query.bookmarkId) {
        this.formBookmark.id = this.$route.query.id || this.$route.query.bookmarkId;
      }
      if (this.$route.query.compId) {
        this.formComponent.id = this.$route.query.compId;
      }
      if (this.$route.query.boardId) {
        this.formComponent.boardId = this.$route.query.boardId;
      }
    },

    async initData() {
      try {
        this.initLoading = true;
        try {
          await this.fetchBaseData();
        } catch (e) {
          this.$message('warning', (e && e.message) || '系统异常，请稍后重试');
        }

        this.resetAll(); // 重置放这里，是为了能赋值第一个事件

        if (this.formBookmark.id) {
          await this.fetchBookmarkData();
          this.handleGetData();
        }
        if (this.formComponent.id) {
          await this.fetchComponentInfo();
          this.handleGetData();
        }
        if (this.formComponent.boardId) {
          await this.fetchBoardInfo();
        }

        // 这一步在后面，是因为需要前面确定具体的事件列表
        await this.getAllConfigEventTargetColumn();
        this.updateAllZhibiaoTitle();

        // 判断是否出现新手指引
        // setTimeout(() => {
        //   this.checkGuide();
        // }, 20);
      } catch (e) {
        console.error(e);
      } finally {
        this.initLoading = false;
      }
    },

    async fetchBaseData() {
      const promiseArr = [];

      promiseArr.push(getEventList({ params: { getType: 'all', hasData: 1 } }));
      // promiseArr.push(getTargetColumn({}));
      // promiseArr.push(getPackageList({ params: { paged: 0, pageNo: 1, pageSize: 10000 } }));
      promiseArr.push(getAllProperty({ params: { hasData: 1, isVisible: 1 } }));
      promiseArr.push(getAllEventProperty({}));
      promiseArr.push(getConditionOperator({}));
      const [
        eventListData,
        // targetColumnData,
        // packageListData,
        propertyListData,
        allEventPropertyData,
        conditionOperatorData,
      ] = await Promise.all(promiseArr);

      this.eventSelectOptions = eventListData;
      // this.eventStatZhibiaoOptions = targetColumnData.map(item => ({
      //   label: item.desc,
      //   val: item.type,
      // }));
      // this.eventTargetColumnDataMap = targetColumnData;
      this.conditionPropertyOptions = propertyListData.list.map(item => ({
        propertyName: item.name,
        propertyDesc: item.chineseName,
        propertyDataType: item.javaType,
        propertyType: item.propertyType,
        propertyValueTipVOList: item.propertyValueTipVOList,
      }));
      // 这里为什么要clone一份，是因为属性维度，需要有置灰的逻辑
      this.shuxingWeiduOptions = cloneDeep(this.conditionPropertyOptions);
      this.allEventProperty = allEventPropertyData;
      // this.renqunWeiduOptions = packageListData.list.map(item => ({ label: item.packageName, value: item.id }));
      this.renqunWeiduOptions.unshift({ label: '总体', value: 'all' });

      this.conditionOperatorOptions = conditionOperatorData;
    },

    async fetchBookmarkData() {
      try {
        const { id } = this.formBookmark;
        const retData = await getBookmarkDetail({ params: { id } });
        // console.log('retData', retData);

        this.formBookmark.bookmarkName = retData.bookmarkName;
        this.formBookmark.remark = retData.remark;

        this.recoverConfig(retData);
      } catch (e) {
        console.error(e);
      }
    },

    async fetchComponentInfo() {
      try {
        const { id } = this.formComponent;
        const retData = await getComponentList({ params: { id } });
        if (!retData || !retData.length) return;
        this.chartType = retData[0].chartType; // chart_line、histogram、stacked_bar_chart、table、number
        if (['chart_line', 'table', 'number'].indexOf(this.chartType) !== -1) {
          // 如果是这三种，统一为chart_line，因为图表类型没有table，number之说
          this.chartType = 'chart_line';
        }

        Object.assign(this.formComponent, retData[0]);
        const params = this.formComponent.analysisModelDetailVO || {};
        this.recoverConfig(params);
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBoardInfo() {
      try {
        const res = await getBoardDetail({ params: { boardId: this.formComponent.boardId } });
        this.boardInfo = res;
        if (!this.boardInfo.componentList) {
          this.boardInfo.componentList = [];
        }
        if (!this.boardInfo.globalConditionConfigVO) {
          this.boardInfo.globalConditionConfigVO = {};
        }
      } catch (e) {
        console.error(e);
      }
    },

    recoverConfig(cfg) {
      if (cfg.unit) {
        this.formUnit = cfg.unit || 'day';
      }
      this.dateInfo = cfg.dateInfo;
      if (cfg.compareDateInfo) {
        this.compareDateInfo = cfg.compareDateInfo;
        this.formShowCompareDate = true;
      }
      this.globalFilterType = cfg.connectors;

      if (cfg.packageId) {
        this.renqunWeiduList = [{ val: cfg.packageId }];
      }

      const wdList = [];
      if (cfg.groupBy) {
        const groupByArr = cfg.groupBy.split(',');
        if (groupByArr.length) {
          groupByArr.forEach(i => {
            wdList.push({ val: trim(i) });
          });
          this.shuxingWeiduList = wdList;
        }
      }

      if (cfg.conditionModels) {
        this.globalFilterList = makeFilterList(this.conditionOperatorOptions, cfg.conditionModels);
      }
      if (cfg.globalFilters && cfg.globalFilters.globalFilterList) {
        this.controlGroupList = cfg.globalFilters.globalFilterList.map(item => {
          return {
            name: item.globalFilterName,
            filterType: item.connectors,
            filterList: makeFilterList(this.conditionOperatorOptions, item.conditionModels),
          };
        });
      }

      if (cfg.targetModels) {
        this.zhibiaoList.splice(0, this.zhibiaoList.length); // 清空占位的指标
        cfg.targetModels.forEach(targetItem => {
          const zhibiaoItem = {
            zhibiaoTitle: targetItem.targetName,
            zhibiaoTitleUserChanged: true,
            filterType: targetItem.connectors,
            filterList: makeFilterList(this.conditionOperatorOptions, targetItem.conditionModels),
          };
          const eventList = [];
          if (targetItem.targetColumn) {
            targetItem.targetColumn.forEach(item => {
              const eventObj = {
                eventName: item.eventName,
                eventShowName: item.eventShowName,
                targetOperator: item.targetOperator,
                leftBracket: item.leftBracket,
                rightBracket: item.rightBracket,
                eventTargetColumn: item.eventTargetColumn,
                popoverStep: 1,
                filterType: item.connectors,
                filterList: makeFilterList(this.conditionOperatorOptions, item.conditionModels),
              };
              eventList.push(eventObj);
            });
          }
          zhibiaoItem.eventList = eventList;

          this.zhibiaoList.push(zhibiaoItem);
        });
      }
    },

    validConfig() {
      if (this.baseDate.length < 1) {
        this.iMessage('请选择日期');
        return false;
      }
      if (this.showCompareDate && this.compareDate.length < 1) {
        this.iMessage('请选择对比日期');
        return false;
      }
      if (dayjs(this.baseDate[1]).diff(dayjs(this.baseDate[0]), 'day') >= 31) {
        this.iMessage('日期范围不能超过31天');
        return false;
      }
      if (this.showCompareDate && dayjs(this.compareDate[1]).diff(dayjs(this.compareDate[0]), 'day') >= 31) {
        this.iMessage('对比日期范围不能超过31天');
        return false;
      }

      const targetModels = this.buildTargetModels();
      const tmpTargetModels = targetModels.filter(item => !item.targetName);
      if (tmpTargetModels.length) {
        this.iMessage({ type: 'warning', message: '指标名称不能为空' });
        return false;
      }

      const targetNameArr = targetModels.map(item => item.targetName);
      if (targetNameArr.length !== uniq(targetNameArr).length) {
        this.iMessage('指标名称不能重复');
        return false;
      }

      let errMsg;
      targetModels.forEach((tm, tmIdx) => {
        const bracketList = [];
        tm.targetColumn.forEach((tc, tcIdx) => {
          if (!tc.eventName) {
            errMsg = `请先选择第${tmIdx + 1}个指标的第${tcIdx + 1}个事件`;
          }
          if (tc.leftBracket) {
            bracketList.push(true);
          }
          if (tc.rightBracket) {
            if (!bracketList.length) {
              errMsg = `第${tmIdx + 1}个指标的括号匹配不正确`;
            } else {
              bracketList.pop();
            }
          }
        });
        if (bracketList.length) {
          errMsg = `第${tmIdx + 1}个指标的括号匹配不正确`;
        }
      });
      if (errMsg) {
        this.iMessage({ type: 'warning', message: errMsg });
        return false;
      }

      return true;
    },

    handleReset() {
      this.resetConfig();
      this.resetAnalysisData();
      this.getAllConfigEventTargetColumn();
      this.updateAllZhibiaoTitle();
    },

    handleShowSavePopover() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.savePopverVisible = !this.savePopverVisible;
    },

    handleHideSavePopover() {
      this.savePopverVisible = false;
    },

    // 保存或更新组件
    async handleSaveComponent(type, form) {
      const self = this;
      async function gogo() {
        const validRet = self.validConfig();
        if (!validRet) {
          return;
        }
        const eventAnalysisReq = self.buildGetDataParams();
        if (self.showCompareDate) {
          eventAnalysisReq.compareDateInfo = self.compareDateInfo;
        } else {
          eventAnalysisReq.compareDateInfo = null;
        }
        eventAnalysisReq.analysisType = 'event';

        const params = {
          analysisType: 'event',
          analysisModelReq: JSON.stringify(eventAnalysisReq),
        };

        const propArr = ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext'];
        switch (form.chartType) {
          case 'number':
            propArr.push('primaryIndex');
            propArr.push('secondaryIndex');
            break;
          case 'table':
            propArr.push('dimensionType');
            break;
          case 'chart_line':
          case 'histogram':
          case 'circular_graph':
          case 'stacked_bar_chart':
            propArr.push('indexTabDisplay');
            propArr.push('indexSet');
            propArr.push('lineCount');
            break;
          default:
            break;
        }

        const tmpObj = pick(form, propArr);
        Object.assign(params, tmpObj);

        // console.log('handleSaveComponent params', params);//在这里打印传过去的参数

        // eslint-disable-next-line no-unused-vars
        let retData;
        try {
          self.loadingSave = true;
          if (type === 'new') {
            await createComponent({ data: params });
          } else {
            await modifyComponent({ data: params });
          }
        } finally {
          self.loadingSave = false;
        }

        self.iMessage({
          type: 'success',
          message: '保存成功',
        });

        self.handleHideSavePopover();

        setTimeout(() => {
          self.$router.replace({
            name: 'OverviewHome',
            query: {
              boardId: params.boardId,
            },
          });
        }, 100);

        // if (type === 'new') {
        //   self.$router.replace({
        //     name: 'customOverviewHome',
        //     query: {
        //       boardId: self.formComponent.boardId,
        //     },
        //   });
        // } else {
        //   setTimeout(() => {
        //     window.dispatchEvent(new CustomEvent('routerReload'));
        //   }, 300);
        // }
      }
      await gogo();
    },

    // 保存或更新书签
    async handleSaveBookmark(form) {
      const self = this;
      async function gogo() {
        const validRet = self.validConfig();
        if (!validRet) {
          return;
        }
        const params = self.buildGetDataParams();
        if (self.showCompareDate) {
          params.compareDateInfo = self.compareDateInfo;
        } else {
          params.compareDateInfo = null;
        }
        const { id, bookmarkName, remark } = form;
        params.bookmarkName = bookmarkName;
        params.remark = remark;
        params.analysisType = 'event';
        params.id = id;

        // console.log('handleSaveBookmark params', params);

        let retData;
        try {
          self.loadingSave = true;
          retData = await saveBookmark({ data: params });
        } finally {
          self.loadingSave = false;
        }

        self.iMessage({
          type: 'success',
          message: '保存成功',
        });

        self.handleHideSavePopover();

        // self.$router.replace({
        //   name: 'customAnalysisEventAnalysis',
        //   query: {
        //     bookmarkId: params.id || retData,
        //   },
        // });

        if (params.id) {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('routerReload'));
          }, 400);
        }
      }
      await gogo();
    },

    async handleGetData() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }

      this.loadingData = true;

      let retData;
      let retDataCompare;

      const isFind = this.shuxingWeiduList.find(item => item.val !== 'all');
      if (!isFind && this.chartType === 'circular_graph') {
        this.chartType = 'chart_line';
      }
      // 每次请求要记住当次请求的时间粒度以及是否开启比较
      this.unit = this.formUnit;
      this.showCompareDate = this.formShowCompareDate;

      try {
        // const promiseArr = [];
        // promiseArr.push((async () => {
        const params = this.buildGetDataParams();
        this.lastGetDataParams = params; // 记录最后一次的请求参数，给保存人群功能使用

        const uuid = await getEventAnalysisData({ data: params });
        // console.log('uuid', uuid);
        this.pa = new PollingAction({
          delay: 2000,
          handler: async () => {
            retData = await pollingEventData({ params: { uuid } });
            if (!retData) {
              return true;
            }
            return false;
          },
        });
        await this.pa.start();
        if (!retData) {
          throw new Error('retData is null');
        }
        // })());

        if (this.showCompareDate) {
          // promiseArr.push((async () => {
          const paramsCompare = this.buildGetDataParams(true);
          paramsCompare.isCompare = true;
          this.lastGetDataParamsCompare = paramsCompare;
          const uuid2 = await getEventAnalysisData({ data: paramsCompare });
          // console.log('uuid2', uuid2);
          this.pa2 = new PollingAction({
            delay: 2000,
            handler: async () => {
              retDataCompare = await pollingEventData({ params: { uuid: uuid2 } });
              if (!retDataCompare) {
                return true;
              }
              return false;
            },
          });
          await this.pa2.start();
          if (!retDataCompare) {
            throw new Error('retData is null');
          }
          // })());
        }

        // await Promise.all(promiseArr);
      } catch (e) {
        console.error(e);
        // throw e;
      } finally {
        this.loadingData = false;
      }

      this.groupDataObjList = retData;

      if (this.showCompareDate) {
        if (!retDataCompare) {
          return;
        }
        this.groupDataObjListCompare = retDataCompare;
      }

      this.makeData();
    },

    makeData() {
      // 整理数据

      let legendDataTotal = [];
      let legendDataWdTotal = [];

      const { list, legendData, legendDataWd } = analysisDataTranslate(this.groupDataObjList, this.lastGetDataParams);
      legendDataTotal = legendDataTotal.concat(legendData);
      legendDataWdTotal = legendDataWdTotal.concat(legendDataWd);

      this.chartData.seriesMap = list;

      if (this.groupDataObjListCompare && this.groupDataObjListCompare.list && this.groupDataObjListCompare.dates) {
        const {
          list: listCompare,
          legendData: legendDataCompare,
          legendDataWd: legendDataWdCompare,
        } = analysisDataTranslate(this.groupDataObjListCompare, this.lastGetDataParamsCompare);
        this.chartData.seriesMapCompare = listCompare;

        legendDataTotal = legendDataTotal.concat(legendDataCompare);
        legendDataWdTotal = legendDataWdTotal.concat(legendDataWdCompare);
      }

      this.chartData.legendData = uniqWith(legendDataTotal, (a, b) => {
        return a.name === b.name;
      });
      this.chartData.legendDataWd = uniqWith(legendDataWdTotal, (a, b) => {
        return a.name === b.name;
      });
    },

    buildGetDataParams(isCompare) {
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all');
      const renqunList = this.renqunWeiduList.filter(item => item.val !== 'all');
      const params = {
        // connectors: this.globalFilterType,
        groupBy: weiduList.map(item => item.val).join(','),
        // conditionModels: this.buildConditionModels(this.globalFilterList),
        globalFilters: {
          globalFilterList: this.controlGroupList.map((item, idx) => {
            return {
              globalFilterIndex: idx,
              globalFilterName: item.name,
              connectors: item.filterType,
              conditionModels: this.buildConditionModels(item.filterList),
            };
          }),
        },
        targetModels: this.buildTargetModels(),
        packageId: renqunList.length ? renqunList[0].val : undefined,
        unit: this.isDisabledByChartType ? 'day' : this.formUnit,
      };

      if (isCompare) {
        params.compareDateInfo = this.compareDateInfo;
      } else {
        params.dateInfo = this.dateInfo;
      }

      console.log('params', params);

      return params;
    },

    buildConditionModels(filterList) {
      const list = [];
      filterList.forEach(filterItem => {
        const item = {
          column: filterItem.column,
          conditionOperator: filterItem.conditionOperator,
          value: '',
        };
        if (Array.isArray(filterItem.value)) {
          item.value = filterItem.value.join(',');
        } else {
          item.value = filterItem.value;
        }

        list.push(item);
      });
      return list;
    },

    buildTargetModels() {
      const list = [];
      this.zhibiaoList.forEach(zhibiaoItem => {
        const item = {
          targetName: zhibiaoItem.zhibiaoTitle,
          connectors: zhibiaoItem.filterType,
          conditionModels: this.buildConditionModels(zhibiaoItem.filterList),
          targetColumn: [],
        };

        zhibiaoItem.eventList.forEach((eventItem, eventItemIdx) => {
          const nItem = {
            eventName: eventItem.eventName,
            eventTargetColumn: eventItem.eventTargetColumn,
            targetOperator: eventItemIdx === 0 ? '' : eventItem.targetOperator, // 第一个的不要传
            leftBracket: eventItem.leftBracket,
            rightBracket: eventItem.rightBracket,
            connectors: eventItem.filterType,
            conditionModels: this.buildConditionModels(eventItem.filterList),
          };
          item.targetColumn.push(nItem);
        });

        list.push(item);
      });
      return list;
    },

    handleAddZhibiao() {
      if (this.zhibiaoList.length >= 5) {
        this.iMessage('最多添加5个自定义指标');
        return;
      }
      let eventName;
      if (this.eventSelectOptions.length) {
        eventName = this.eventSelectOptions[0].eventName;
      }

      const zhibiaoItem = {
        zhibiaoTitle: `自定义指标${this.zhibiaoList.length + 1}`,
        zhibiaoTitleUserChanged: false,
        eventList: [
          {
            eventName,
            eventShowName: '',
            targetOperator: '/',
            leftBracket: false,
            rightBracket: false,
            eventTargetColumn: { type: 'totalCount' },
            filterType: 'and',
            filterList: [],
            showPopover: false,
          },
        ],
        filterType: 'and',
        filterList: [],
      };
      this.updateSingleZhibiaoTitle(zhibiaoItem);
      this.zhibiaoList.push(zhibiaoItem);
    },

    handleRemoveZhibiao(idx) {
      this.zhibiaoList.splice(idx, 1);
    },
    handleAddWarn(index) {
      const zhibiaoItem = this.zhibiaoList[index];

      const targetModel = {
        targetName: zhibiaoItem.zhibiaoTitle,
        connectors: zhibiaoItem.filterType,
        conditionModels: this.buildConditionModels(zhibiaoItem.filterList),
        targetColumn: [],
      };

      zhibiaoItem.eventList.forEach((eventItem, eventItemIdx) => {
        const nItem = {
          eventName: eventItem.eventName,
          eventShowName: this.getEventShowName(eventItem),
          eventTargetColumn: eventItem.eventTargetColumn,
          eventTargetColumnShowVal: this.getEventTargetColumnShowVal(eventItem),
          targetOperator: eventItemIdx === 0 ? '' : eventItem.targetOperator, // 第一个的不要传
          leftBracket: eventItem.leftBracket,
          rightBracket: eventItem.rightBracket,
          connectors: eventItem.filterType,
          conditionModels: this.buildConditionModels(eventItem.filterList),
        };
        targetModel.targetColumn.push(nItem);
      });

      targetModel.conditionModels.forEach(conditionModel => {
        const item = this.conditionPropertyOptions.find(i => i.propertyName === conditionModel.column);
        conditionModel.columnShowVal = item.propertyDesc;
        conditionModel.conditionOperatorDetail = this.conditionOperatorOptions.find(
          i => i.type === conditionModel.conditionOperator,
        );
      });
      targetModel.targetColumn.forEach(targetColumn => {
        targetColumn.conditionModels.forEach(conditionModel => {
          const item = this.conditionPropertyOptions.find(i => i.propertyName === conditionModel.column);
          conditionModel.columnShowVal = item.propertyDesc;
          conditionModel.conditionOperatorDetail = this.conditionOperatorOptions.find(
            i => i.type === conditionModel.conditionOperator,
          );
        });
      });

      // editTargetWarn({
      //   form: {
      //     id: null,
      //     warnName: '',
      //     warnRemark: '',
      //     eventAnalysisReq: {
      //       analysisType: 'event',
      //       targetModels: [targetModel],
      //     },
      //     quotaPeriod: '2',
      //     weekDay: [],
      //     dayHour: [],
      //     warnRules: [],
      //     pushWay: '1',
      //     pushIds: [],
      //     pushPersons: [],
      //     targetName: targetModel.targetName,
      //   },
      // })
      //   .then(() => {
      //     this.iMessage.success('预警添加成功');
      //   })
      //   .catch(action => {
      //     console.log(action);
      //   });
    },

    handleZhibiaoTitleChange(zhibiaoItem) {
      zhibiaoItem.zhibiaoTitleUserChanged = true;
    },

    handleAddZhibiaoFilterItem(zhibiaoItem) {
      if (zhibiaoItem.filterList.length >= 5) {
        this.iMessage('最多添加5个筛选项');
        return;
      }
      const propList = this.calZhibiaoPropOptions(zhibiaoItem);
      this.addFilterItem(zhibiaoItem.filterList, propList);
    },

    handleAddZhibiaoEvent(zhibiaoItem) {
      if (zhibiaoItem.eventList.length >= 5) {
        this.iMessage('最多添加5个事件');
        return;
      }
      let eventName;
      if (this.eventSelectOptions.length) {
        eventName = this.eventSelectOptions[0].eventName;
      }

      zhibiaoItem.eventList.push({
        eventName,
        eventShowName: '',
        targetOperator: '/',
        leftBracket: false,
        rightBracket: false,
        eventTargetColumn: { type: 'totalCount' },
        filterType: 'and',
        filterList: [],
      });

      this.$nextTick(() => {
        const zhibiaoProps = this.calZhibiaoPropOptions(zhibiaoItem);
        this.removeDirtyProps(zhibiaoItem.filterList, zhibiaoProps);
      });
    },

    handleRemoveZhibiaoEvent(zhibiaoItem, eventItemIdx) {
      zhibiaoItem.eventList.splice(eventItemIdx, 1);
      if (zhibiaoItem.eventList.length <= 1) {
        zhibiaoItem.eventList.forEach(event => {
          event.leftBracket = false;
          event.rightBracket = false;
        });
      }
    },

    handleToggleZhibiaoEventBracket(zhibiaoItem, eventItem, key) {
      eventItem[key] = !eventItem[key];
    },

    handleAddZhibiaoEventFilterItem(eventItem) {
      if (eventItem.filterList.length >= 5) {
        this.iMessage('最多添加5个筛选项');
        return;
      }
      const propList = this.calEventPropOptions(eventItem);
      this.addFilterItem(eventItem.filterList, propList);
    },

    getEventShowName(eventItem) {
      const findEvent = this.eventSelectOptions.find(item => item.eventName === eventItem.eventName);
      return findEvent ? findEvent.eventShowName : '';
    },

    getEventTargetColumnOptions(eventItem) {
      if (!this.eventTargetColumnDataMap[eventItem.eventName]) {
        // eventItem.eventTargetColumn = { type: 'totalCount' };
        return [{ type: 'totalCount', desc: '总次数' }];
      }
      return this.eventTargetColumnDataMap[eventItem.eventName];
    },

    getEventTargetColumnShowVal(eventItem) {
      const eventTargetColumnData = this.eventTargetColumnDataMap[eventItem.eventName] || [];

      const { eventTargetColumn } = eventItem;
      if (typeof eventTargetColumn === 'string') {
        const columnData = eventTargetColumnData.find(item => item.type === eventTargetColumn);
        return columnData ? [columnData.desc] : [];
      }

      const { type, calcType } = eventTargetColumn;
      const columnData = eventTargetColumnData.find(item => item.type === type);
      const showVal = columnData ? [columnData.desc] : [];
      if (columnData && calcType && columnData.calcList) {
        const calcData = columnData.calcList.find(item => item.calcType === calcType);
        // eslint-disable-next-line no-unused-expressions
        calcData && showVal.push(calcData.calcDesc);
      }

      return showVal;
    },

    async handelEventChange(zhibiaoItem, eventItem, $event) {
      eventItem.eventShowName = $event.eventShowName;
      await this.getEventTargetColumn(eventItem.eventName);

      const options = this.eventTargetColumnDataMap[eventItem.eventName];
      const valObj = { type: '' };
      if (options && options.length) {
        const firstColumn = options[0];
        valObj.type = firstColumn.type;
        if (firstColumn.calcList && firstColumn.calcList.length) {
          valObj.calcType = firstColumn.calcList[0].calcType;
        }
      }
      eventItem.eventTargetColumn = valObj;

      this.updateSingleZhibiaoTitle(zhibiaoItem);

      // 事件变化了，对应的筛选项也要调整
      this.$nextTick(() => {
        this.handleFixFilterList(zhibiaoItem, eventItem);
      });
    },

    handleEventTargetColumnChange(zhibiaoItem) {
      this.updateSingleZhibiaoTitle(zhibiaoItem);
    },

    handleFixFilterList(zhibiaoItem, eventItem) {
      const eventProps = this.calEventPropOptions(eventItem);
      this.removeDirtyProps(eventItem.filterList, eventProps);

      const zhibiaoProps = this.calZhibiaoPropOptions(zhibiaoItem);
      this.removeDirtyProps(zhibiaoItem.filterList, zhibiaoProps);
    },

    handleShowEventPopover(zhibiaoItem, eventItem, step) {
      // console.log('step', step);
      eventItem.popoverStep = step;
      // eventItem.showPopover = !eventItem.showPopover;
    },

    handleHideEventPopover(zhibiaoItem, eventItem) {
      eventItem.showPopover = false;
    },

    handleAddGlobalFilterItem() {
      if (this.globalFilterList.length >= 5) {
        this.iMessage('最多添加5个筛选项');
        return;
      }
      this.addFilterItem(this.globalFilterList, this.calGlobalPropOptions(this.conditionPropertyOptions));
    },

    handleAddControlGroup() {
      if (this.controlGroupList.length >= 5) {
        this.iMessage('最多添加5个对照组');
        return;
      }
      this.controlGroupList.push({
        name: '全体用户',
        filterType: 'or',
        filterList: [{ column: '', conditionOperator: '', value: undefined }],
      });
    },

    handleRemoveControlGroup(cg, idx) {
      this.controlGroupList.splice(idx, 1);
    },

    handleAddCgFilterItem(cg) {
      if (cg.filterList.length >= 5) {
        this.iMessage('最多设置5个条件');
        return;
      }
      this.addFilterItem(cg.filterList, this.calGlobalPropOptions(this.conditionPropertyOptions));
    },

    handleCgFilterEmpty(cg, idx) {
      this.handleRemoveControlGroup(cg, idx);
    },

    addFilterItem(list, propList) {
      const item = { column: '', conditionOperator: '', value: undefined };
      const nPropList = propList.filter(i => i.propertyType === 1); // 只取事件属性
      if (nPropList.length) {
        const tmpPropertyItem = nPropList[0];
        item.column = tmpPropertyItem.propertyName;
        // eslint-disable-next-line max-len
        const tmpOperatorArr = this.conditionOperatorOptions.filter(
          i => i.javaType === tmpPropertyItem.propertyDataType,
        );
        if (tmpOperatorArr.length) {
          item.conditionOperator = tmpOperatorArr[0].type;
        }
      }
      list.push(item);
    },

    getFilterEventSelectOptions(eventItem) {
      // eslint-disable-next-line max-len
      return this.eventSelectOptions.filter(
        item => !eventItem.eventNameSearch || item.eventDesc.includes(eventItem.eventNameSearch),
      );
    },

    handleShuxingWeiduChange() {
      this.calGlobalPropOptions(this.shuxingWeiduOptions).forEach(swo => {
        if (this.shuxingWeiduList.find(sw => sw.val === swo.propertyName)) {
          swo.disabled = true;
        } else {
          swo.disabled = false;
        }
      });
    },

    handleRemoveShuxingWeidu(idx) {
      this.shuxingWeiduList.splice(idx, 1);
      if (this.shuxingWeiduList.length <= 0) {
        this.handleAddShuXingWeidu();
      }
      this.handleShuxingWeiduChange();
    },

    handleAddShuXingWeidu() {
      if (this.shuxingWeiduList.length >= 5) {
        this.iMessage('最多配置5个属性');
        return;
      }
      this.shuxingWeiduList.push({
        val: 'all',
      });
      this.handleShuxingWeiduChange();
    },

    handleDateChange() {},

    handleAddCompareDate() {
      this.formShowCompareDate = true;
      this.compareDateInfo = {
        timeType: 'static',
        startTime: dayjs().subtract(14, 'day').format('YYYYMMDD'),
        endTime: dayjs().subtract(8, 'day').format('YYYYMMDD'),
      };
      this.handleGetData();
    },

    handleRemoveCompareDate() {
      this.formShowCompareDate = false;
    },

    handleChangeTableShowType(t) {
      this.tableShowType = t;
    },

    handleChangeTopN(N) {
      this.topN = N;
    },

    handleLegendSearchWordChange(w) {
      this.legendSearchWord = w;
    },

    // 查询页面上配置的所有事件的属性
    async getAllConfigEventTargetColumn() {
      const events = [];
      // 把第一个事件默认带上，因为新增组合或者指标的时候，会默认选中第一个事件
      if (this.eventSelectOptions.length) {
        events.push(this.eventSelectOptions[0].eventName);
      }
      this.zhibiaoList.forEach(item => {
        item.eventList.forEach(ev => {
          if (ev.eventName && !events.includes(ev.eventName)) {
            events.push(ev.eventName);
          }
        });
      });
      await this.getEventTargetColumn(events.join(','));
    },

    updateAllZhibiaoTitle() {
      this.zhibiaoList.forEach(item => {
        this.updateSingleZhibiaoTitle(item);
      });
    },

    updateSingleZhibiaoTitle(zhibiaoItem) {
      if (!zhibiaoItem.zhibiaoTitleUserChanged) {
        zhibiaoItem.zhibiaoTitle = this.makeZhiBiaoTitle(zhibiaoItem);
      }
    },

    makeZhiBiaoTitle(zhibiaoItem) {
      const eventItem = zhibiaoItem.eventList[0];
      const eventShowName = this.getEventShowName(eventItem);
      const valArr = this.getEventTargetColumnShowVal(eventItem);
      return `${eventShowName}的${valArr.join('')}`;
    },

    async getEventTargetColumn(events) {
      // let event = events;
      // if (!event && this.eventSelectOptions.length) {
      //   event = this.eventSelectOptions[0].eventName;
      // }
      if (!events) return;
      const narr = [];
      const arr = events.split(',');
      arr.forEach(en => {
        if (!this.eventTargetColumnDataMap[en]) {
          narr.push(en);
        }
      });
      if (narr.length <= 0) return;
      const retData = await getTargetColumn({ params: { events: narr.join(',') } });
      Object.assign(this.eventTargetColumnDataMap, retData);
    },

    calEventPropOptions(eventItem) {
      const item = this.allEventProperty.find(i => i.eventName === eventItem.eventName);
      const jiaojiProperList = item
        ? item.propertyList.map(p => ({
            propertyName: p.name,
            propertyDesc: p.chineseName,
            propertyDataType: p.javaType,
            propertyType: p.propertyType,
          }))
        : [];
      let propertyList = this.conditionPropertyOptions;
      if (jiaojiProperList.length > 0) {
        propertyList = this.calPropOptionsByJiaoJiEventPropList(propertyList, jiaojiProperList);
      }
      return propertyList;
    },

    calZhibiaoPropOptions(zhibiaoItem) {
      const arrPropertyList = this.allEventProperty
        .filter(item => zhibiaoItem.eventList.some(i => i.eventName === item.eventName))
        .map(item => item.propertyList);

      const arrJiaoJi = propertyArrJiaoJi(arrPropertyList);
      const jiaojiProperList = arrJiaoJi.map(p => ({
        propertyName: p.name,
        propertyDesc: p.chineseName,
        propertyDataType: p.javaType,
        propertyType: p.propertyType,
      }));

      let propertyList = this.conditionPropertyOptions;
      if (jiaojiProperList.length > 0) {
        propertyList = this.calPropOptionsByJiaoJiEventPropList(propertyList, jiaojiProperList);
      }
      return propertyList;
    },

    calGlobalPropOptions(propertyOptions) {
      const evList = [];
      this.zhibiaoList.forEach(zhibiao => {
        zhibiao.eventList.forEach(ev => {
          if (!evList.some(i => i.eventName === ev.eventName)) {
            evList.push(ev);
          }
        });
      });

      const arrPropertyList = this.allEventProperty
        .filter(item => evList.some(i => i.eventName === item.eventName))
        .map(item => item.propertyList);

      const arrJiaoJi = propertyArrJiaoJi(arrPropertyList);
      const jiaojiProperList = arrJiaoJi.map(p => ({
        propertyName: p.name,
        propertyDesc: p.chineseName,
        propertyDataType: p.javaType,
        propertyType: p.propertyType,
      }));

      let propertyList = propertyOptions;
      if (jiaojiProperList.length > 0) {
        propertyList = this.calPropOptionsByJiaoJiEventPropList(propertyList, jiaojiProperList);
      }
      return propertyList;
    },

    calPropOptionsByJiaoJiEventPropList(propertyList, jiaojiProperList) {
      return propertyList.filter(item => {
        if (item.propertyType === 1) {
          // 目前只处理事件属性
          if (jiaojiProperList.findIndex(i => i.propertyName === item.propertyName) === -1) {
            return false;
          }
          return true;
        }
        return true;
      });
    },

    removeDirtyProps(list, propList) {
      const delArr = [];
      list.forEach(item => {
        if (!propList.some(i => i.propertyName === item.column)) {
          delArr.push({ propertyName: item.column });
        }
      });
      console.log('delArr', JSON.stringify(delArr, null, 2));
      delArr.forEach(item => {
        const findIdx = list.findIndex(i => i.column === item.propertyName);
        if (findIdx !== -1) {
          console.log('删除元素', findIdx);
          list.splice(findIdx, 1);
        }
      });
    },

    handleBack() {
      // console.log('handleBack');
      // this.$router.go(-1);
      this.$router.replace({
        name: 'OverviewHome',
        query: {
          boardId: this.formComponent.boardId,
        },
      });
    },

    async checkGuide() {
      const me = this;
      const code = 'CustomZone.EventAnalysis.FirstVisit';
      this.guideDriver = this.initGuideDriver({
        onReset() {
          me.setVisitedStatus(code, 1);
        },
      });
      this.initGuideSteps();
      const isVisited = await this.getVisitedStatus(code);
      if (!isVisited) {
        this.guideDriver.start();
      }
    },

    initGuideSteps() {
      const me = this;
      const { guideDriver } = this;
      guideDriver.defineSteps([
        {
          element: '.new-guide-step-1',
          popover: {
            className: 'first-step-popover-class',
            closeBtnText: '跳过(1/5)',
            title: '这里可选择一个需要分析的事件和指标单位，+筛选可实现更高级的配置',
            description: '这里可选择一个需要分析的事件和指标单位，+筛选可实现更高级的配置',
          },
        },
        {
          element: '.new-guide-step-2',
          popover: {
            closeBtnText: '跳过(2/5)',
            title: '点击这里可以再添加一个分析指标',
            description: '点击这里可以再添加一个分析指标',
          },
        },
        {
          element: '.new-guide-step-3',
          popover: {
            closeBtnText: '跳过(3/5)',
            title: '点击这里可为全部事件添加筛选项让分析更准确',
            description: '点击这里可为全部事件添加筛选项让分析更准确',
          },
        },
        {
          element: '.new-guide-step-4',
          popover: {
            closeBtnText: '跳过(4/5)',
            title: '这里可指定人群参与当前分析',
            description: '这里可指定人群参与当前分析',
          },
        },
        {
          element: '.new-guide-step-5',
          popover: {
            closeBtnText: '跳过(5/5)',
            title: '选择维度后，分析结果会按所选属性来分组展示',
            description: '选择维度后，分析结果会按所选属性来分组展示',
          },
          onNext() {
            me.highlightTriggerElement();
          },
        },
      ]);
    },

    handleStartGuide() {
      this.guideDriver.start();
    },

    iMessage(v) {
      if (typeof v === 'string') {
        this.$message('warning', v);
      } else {
        const { type, message } = v;
        this.$message(type, message);
      }
    },
  },

  beforeDestroy() {
    if (this.pa) {
      this.pa.stop();
    }
    if (this.pa2) {
      this.pa2.stop();
    }
  },
};
</script>

<style lang="less" scoped>
@import './event-analysis.less';
</style>

<style lang="less">
@import './event-analysis-no-scoped.less';
</style>
